export default __webpack_public_path__ + "static/media/token_sOHM.6716c283.svg";